(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-slider"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
		var thumbnail = event.target.closest('[data-thumbnail-target]');
		if (!thumbnail) return;

		var mediaId = thumbnail.dataset.thumbnailTarget;
		var target = document.querySelector(
			'.c-product__media-list [data-media-id="' + mediaId + '"]'
		);
		var targetItem = target && target.closest('.c-product__media-item');

		if (targetItem) {
			targetItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	});
  } catch(e) { console.error(e); }
})();

})();
